@reference "@glow/tailwind-config/reference.css";

.button {
  @apply p-0;
  @apply bg-transparent;
  @apply border-none;
  @apply cursor-pointer;
}

.items-container {
  @apply z-50;
  @apply absolute;
  @apply opacity-0;
}

.items {
  @apply max-w-[calc(100vw-2rem)];
  @apply bg-theme-surface;
  @apply shadow-dark;
  @apply rounded-sm;
  @apply p-2;
  @apply flex;
  @apply flex-col;
  @apply justify-items-stretch;
  min-width: 235px;
}

.items:focus {
  outline: none;
}

.item {
  @apply block;
  @apply gap-4;
  @apply items-center;
  @apply text-left;
  @apply p-3;
  @apply cursor-pointer;
  @apply rounded-sm;
  @apply text-sm;
  @apply text-black;
  @apply no-underline;
  @apply bg-transparent;
  @apply border-none;
}

.item:not([disabled]) {
  @apply w-full;
}

.item[disabled] {
  @apply opacity-30;
  @apply cursor-not-allowed;
  @apply pointer-events-none;
}

.item-icon {
  @apply text-base;
  @apply text-emphasis-extra;
  @apply justify-self-center;
  @apply mr-3;
}

.header {
  @apply cursor-default;
  @apply text-xs;
  @apply text-emphasis-medium;
  @apply mt-2;
}
